/* ==========================================================================
   collection.js — the shop all search box.

   Typing filters the cards already on the page rather than navigating to
   Shopify search results. Pressing Enter falls through to a real search so a
   query with no matches on this page still goes somewhere useful.
   ========================================================================== */

(function () {
  'use strict';

  function init() {
    const grid = document.querySelector('[data-product-grid]');
    if (!grid) return;

    const cards = Array.from(grid.querySelectorAll('[data-product-card]'));
    const masonry = window.Theme.masonry(grid, {
      itemSelector: '[data-product-card]',
      colsProperty: '--grid-cols',
      colClass: 'grid__col'
    });

    const empty = document.querySelector('[data-search-empty]');
    const inputs = Array.from(document.querySelectorAll('[data-product-search]'));
    if (!inputs.length) return;

    function apply(rawQuery) {
      const query = rawQuery.trim().toLowerCase();
      let shown = 0;

      cards.forEach(function (card) {
        const match = !query || (card.dataset.title || '').indexOf(query) !== -1;
        card.hidden = !match;
        if (match) shown += 1;
      });

      if (empty) empty.hidden = shown !== 0;
      if (masonry) masonry.relayout();
    }

    inputs.forEach(function (input) {
      input.addEventListener('input', function () {
        apply(input.value);
        // Keep both search boxes (rail + mobile menu) in step.
        inputs.forEach(function (other) {
          if (other !== input) other.value = input.value;
        });
      });

      // Enter submits to Shopify search only when nothing matched here.
      input.form.addEventListener('submit', function (event) {
        const anyVisible = cards.some(function (card) {
          return !card.hidden;
        });
        if (anyVisible) event.preventDefault();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
